import script from "./roleEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./roleEdit.vue?vue&type=script&setup=true&lang=ts"

import "./roleEdit.vue?vue&type=style&index=0&id=5671cfb7&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5671cfb7"]])

export default __exports__